module.exports = __webpack_public_path__ + "static/media/location-icon.adfd4e5a.svg";